import React from "react";
import styles from "./Switch.module.css";
import Flex from "@/components/Flex/Flex";

type SwitchProps = {
  label?: string;
  caption?: string;
  disabled?: boolean;
  onChange: (value: boolean) => void;
  value: boolean;
  labelSide?: "left" | "right";
};

const Switch = ({
  label,
  labelSide = "right",
  caption,
  disabled,
  value: on,
  onChange,
}: SwitchProps) => {

  const handleSwitchOnClick = () => {
    onChange(!on);
  };

  return (
    <Flex
      justify="start"
      align="center"
      direction={labelSide == "left" ? "row-reverse" : "row"}
      className={`${styles.switchContainer} ${disabled ? styles.disabled : ""}`}
    >
      <button
        className={`${styles.switchButton} ${on ? styles.on : ""} ${disabled ? styles.disabledCursor : ""}`}
        disabled={disabled}
        onClick={handleSwitchOnClick}
      >
        <div className={`${styles.switchNub} ${on ? styles.on : ""}`} />
      </button>

      <div className={styles.text}>
        <span>{label}</span>
        {caption && <div className={`weak small-text`}>{caption}</div>}
      </div>
    </Flex>
  );
};

export default Switch;
